import React from 'react';
import { SidebarOption } from './types';
import './Sidebar.scss';

interface SidebarProps {
  selectedOption: SidebarOption | null;
  onOptionClick: (option: SidebarOption) => void;
  options?: SidebarOption[]; // optional override
}

const Sidebar: React.FC<SidebarProps> = ({ selectedOption, onOptionClick, options }) => {
  const baseSidebarOptions: SidebarOption[] = [
    'Last 1 hour',
    'Last 2 hours',
    'Last 4 hours',
    'Last 8 hours',
    'Last 24 hours',
    'Last 7 days',
  ];

  return (
    <nav className='sidebar'>
      {baseSidebarOptions.map((option) => (
        <button
          data-analytics-id='sidebar-option-btn'
          key={option}
          type='button'
          className={`sidebar-option ${selectedOption === option ? 'selected-primary' : ''}`}
          onClick={() => onOptionClick(option)}
        >
          <span className='option-text'>{option}</span>
        </button>
      ))}
    </nav>
  );
};

export default Sidebar;
